import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW9101Component } from './kymw9101.component';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';

/**
 * ログ検索条件画面 モジュール設定クラス
 *
 * @export KYMW9101Module
 * @class KYMW9101Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjInputModule,
    WjNavModule,
  ],
  declarations: [
    KYMW9101Component,
  ],
  providers: [
  ],
})
export class KYMW9101Module {

}
